import map from './page/map';

map();


// WEBPACK FOOTER //
// ./js/map.js